import { useDispatch } from 'react-redux';
import {
  ChangeScreen,
  DisableSpinner,
  CancelSubmit,
} from '../redux/actions/screenActions';
import useUserUUID from './useUserUUID';
import { ApiPostFile } from '../redux/sagas/ApiCall';
import { RejectApiStatus } from '../redux/actions/apiActions';

const useFileUploadAction = () => {
  const dispatch = useDispatch();
  const uuid = useUserUUID();

  const uploadFiles = async (values) => {
    values.append('uuid', uuid);
    try {
      await ApiPostFile('/application/uploadFiles', values, true, {
        'Content-Type': 'multipart/form-data',
      });

      dispatch(
        ChangeScreen({
          link: '/success',
        })
      );
    } catch (e) {
      dispatch(RejectApiStatus({ code: e.response.status }));

      dispatch(DisableSpinner());
      dispatch(CancelSubmit());
    }
  };

  return uploadFiles;
};

export default useFileUploadAction;
